import axios from "axios";
import Kjur from "../utils/jwt";
import moment from "moment";

const bearerToken = Kjur.encode(
  JSON.parse(localStorage.getItem("userDetails"))
);

let axiosConfig = {
  headers: {
    "Content-Type": "application/json; charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
    "Strict-Transport-Security": "max-age=90",
    Authorization: `Bearer ${bearerToken}`,
  },
};

export const fetchCareers = async (data) => {
  const obj = {
    page: data.page,
    limit: data.limit,
    sort_by: "desc",
    sort_order: "date_created",
    keyword: data.keyword
  };

  const encodedData = Kjur.encode(obj);

  return await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/admin/career?token=${encodedData}`,
    axiosConfig
  );
};

export const addCareer = async (job) => {
  const data = {
    job_title: job.jobTitle,
    status: true,
    job_description: job.jobDescription,
    number_of_vacancies: 1,
  };

  const encodedData = Kjur.encode(data);

  return await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/admin/career`,
    { token: encodedData },
    axiosConfig
  );
};

export const deleteCareer = async (clientId) => {
  const data = {
    id: clientId,
  };

  const encodedData = Kjur.encode(data);

  // delete method doesnt do request boyd, it should be params like get
  return await axios.delete(
    `${process.env.REACT_APP_API_BASE_URL}/admin/career/delete?token=${encodedData}`,
    // {token:encodedData},
    axiosConfig
  );
};


export const updateCareer = async (job) => {
  const data = {
    id: job.id,
    job_title: job.jobTitle,
    status: job.status,
    job_description: job.jobDescription,
    number_of_vacancies: 1,
  };

  const encodedData = Kjur.encode(data)

  return await axios.put(`${process.env.REACT_APP_API_BASE_URL}/admin/career/update`,
      {token:encodedData},
      axiosConfig
  )
}
